module.exports = __webpack_public_path__ + "img/victoria_maraia_preview.5cb6dcc7.png";